import {Component, OnInit, Input, EventEmitter} from '@angular/core';
import {FormGroupDirective, ControlContainer, Validators, UntypedFormGroup, UntypedFormControl, AbstractControl} from '@angular/forms';
import { Individual } from '../../model/individual';

@Component({
  selector: 'app-individual',
  templateUrl: './individual.component.html',
  styleUrls: ['./individual.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class IndividualComponent implements OnInit {

  @Input() individual: Individual;
  @Input() isSaving: boolean;
  @Input() existing: boolean;
  @Input() form: UntypedFormGroup;
  @Input() OnSave: EventEmitter<Individual>;

  group: UntypedFormGroup;

  get ind_first_name(): AbstractControl {
    return this.group.get('ind_first_name');
  }

  get ind_badge_name(): AbstractControl {
    return this.group.get('ind_badge_name');
  }

  constructor() { }

  ngOnInit() {
    const ind_first_name = new UntypedFormControl(this.individual.ind_first_name, [ Validators.required]);
    const ind_mid_name = new UntypedFormControl(this.individual.ind_mid_name);
    const ind_last_name = new UntypedFormControl(this.individual.ind_last_name, [ Validators.required]);
    const ind_badge_name = new UntypedFormControl(this.individual.ind_badge_name, [ Validators.required]);

    this.group = new UntypedFormGroup({ ind_first_name, ind_mid_name, ind_last_name, ind_badge_name });
    this.form.addControl('individual', this.group);

    this.OnSave.subscribe(individual => this.Save(individual));
  }

  Save(individual: Individual) {
    const values = this.group.value;

    Object.assign(individual, values);
  }
}
